import React from 'react'
import PropTypes from 'prop-types'
import { MicrositeHeader } from '../../Header/index.js'

export default class MHeader extends React.Component {
  render() {
    const { contentIdentifier, imageLarge, imageSmall, backgroundColor, backgroundContrast } =
      this.props.content
    return (
      <MicrositeHeader
        contentIdentifier={contentIdentifier}
        imageLarge={imageLarge}
        imageSmall={imageSmall}
        backgroundColor={backgroundColor}
        backgroundContrast={backgroundContrast}
      />
    )
  }
}

MHeader.propTypes = {
  content: PropTypes.shape({
    contentIdentifier: PropTypes.string,
    imageLarge: PropTypes.string,
    imageSmall: PropTypes.string,
    backgroundColor: PropTypes.string,
    backgroundContrast: PropTypes.string,
  }),
}
